import { withRouter } from 'react-router';
import YandexMetrika from './YandexMetrika';

export default withRouter(YandexMetrika);
